import type { ReactNode } from 'react';

export const symbol_present_to_all: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M451-522v165q0 12.33 9 20.66 9 8.34 21.23 8.34t20.5-9q8.27-9 8.27-21v-164l58 59q9 9.17 21 9.58 12 .42 21-8.63 9-9.06 9-21.5 0-12.45-9-21.45L500-615q-9-9-21-9t-21 9L348-505q-9 9-8.5 21t9.5 21.39q9 8.61 21.5 8.61t21.5-9l59-59ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
